import React from 'react'
import styled from 'styled-components'
import { Block } from '@mote/ui'
import { CloseOutlineIcon } from '@mote/assets/icons'

export const StepError = ({ message, children, ...rest }) => (
  <Error layout='horizontal' align='center' gap={12} {...rest}>
    <CloseOutlineIcon color='currentColor' />
    {children ?? message}
  </Error>
)

const Error = styled(Block)`
  color: #f44336;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  padding: 12.5px 16px;
  background: rgba(244, 67, 54, 0.1);
  border-radius: 8px;
`
